import styled from 'styled-components';
import MainSectionInner from 'ecosystem-marketplace-core/components/layout/MainSectionInner';
const HomeSectionInner = styled(MainSectionInner).withConfig({
  displayName: "HomeSectionInner",
  componentId: "i6749m-0"
})(["max-width:", "px;"], props => props.maxWidth != null ? props.maxWidth : 940);
export default HomeSectionInner;